import { useLocation, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import type { SuggestedRecipe } from '../lib/recipeTypes'

export default function RecipeSuggestionDetail() {
  const location   = useLocation()
  const navigate   = useNavigate()
  const suggestion = location.state?.suggestion as SuggestedRecipe | undefined

  if (!suggestion) {
    return (
      <main className="px-4 py-6 bg-cream min-h-screen">
        <p className="font-serif italic text-ink-muted">Suggestion not found.</p>
        <button
          onClick={() => navigate('/recipes')}
          className="mt-4 rounded-[10px] bg-forest px-3 py-2 text-[12px] font-semibold text-forest-ink"
        >
          Back to recipes
        </button>
      </main>
    )
  }

  return (
    <main className="px-4 pb-28 min-h-screen bg-cream">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 py-4 text-[13px] text-ink-muted font-medium"
      >
        <ChevronLeft className="h-4 w-4" strokeWidth={1.7} />
        Back
      </button>

      <h1 className="font-serif text-[28px] font-normal tracking-[-0.015em] text-ink leading-[1.1]">
        {suggestion.name}
      </h1>
      <p className="font-serif text-[14px] italic text-ink-muted mt-2 leading-[1.45]">
        {suggestion.why}
      </p>
      <p className="text-[12px] text-ink-muted mt-3">
        {suggestion.prepMinutes} min · serves {suggestion.serves}
      </p>

      <h2 className="font-serif text-[18px] mt-6 mb-2 text-ink">Using what's expiring</h2>
      <ul className="space-y-1.5">
        {suggestion.usesExpiring.map(n => (
          <li key={n} className="flex items-center gap-2 text-[14px] text-ink">
            <span className="h-[6px] w-[6px] rounded-full bg-terracotta shrink-0" />
            {n}
          </li>
        ))}
      </ul>

      <h2 className="font-serif text-[18px] mt-6 mb-2 text-ink">You already have</h2>
      <ul className="space-y-1.5">
        {suggestion.usesOnHand.map(n => (
          <li key={n} className="flex items-center gap-2 text-[14px] text-ink">
            <span className="h-[6px] w-[6px] rounded-full bg-forest shrink-0" />
            {n}
          </li>
        ))}
      </ul>

      {suggestion.needsToBuy.length > 0 && (
        <>
          <h2 className="font-serif text-[18px] mt-6 mb-2 text-ink">Needs shopping</h2>
          <ul className="space-y-1.5">
            {suggestion.needsToBuy.map(n => (
              <li key={n} className="flex items-center gap-2 text-[14px] text-ink-muted">
                <span className="h-[6px] w-[6px] rounded-full bg-ink-muted shrink-0" />
                {n}
              </li>
            ))}
          </ul>
        </>
      )}

      <p className="mt-8 font-serif text-[13px] italic text-ink-muted leading-[1.5]">
        Suggestions are AI-generated and may need adjustment. Always check for allergens and preferences before cooking.
      </p>
    </main>
  )
}
